import urls from './urls'
import Service from '@/utils/fetch'

/**
 * 获取OSS上传签名
 */
// 获取阿里云上传视频图片的action地址
export function _getOSSsignature(data) {
  return Service({
    url: urls.getOSSsignature,
    data
  })
}

// 获取阿里云上传视频图片的action地址(视频十五分钟)
export function _getOSSsignatureRam(data) {
  return Service({
    url: urls.getOSSsignatureRam,
    data
  })
}

export function _getAmBase64(data) {
  return Service({
    url: urls.getAmBase64,
    data
  })
}

//获取单位信息
export function _findAppInfoById(data) {
  return Service({
    url: urls.findAppInfoById,
    data
  })
}

// 设置背景图文案
export function _setPosterName(data,dmId) {
  return Service({
    url: urls.setPosterName,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 设置背景图文案竖版
export function _setPosterNameCode(data,dmId) {
  return Service({
    url: urls.setPosterNameCode,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 认领码背景
export function _editClaimCodeById(data,dmId) {
  return Service({
    url: urls.editClaimCodeById,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 纪念堂操作权限发短信
export function _editUpdateStateSendCode(data,dmId) {
  return Service({
    url: urls.editUpdateStateSendCode,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 纪念堂冻结权限发短信
export function _editSpaceFrozenSendCode(data,dmId) {
  return Service({
    url: urls.editSpaceFrozenSendCode,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 纪念堂上传权限发短信
export function _editUploadStateSendCode(data,dmId) {
  return Service({
    url: urls.editUploadStateSendCode,
    data,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'dmId': dmId
    }
  })
}

// 订单退款验证码
export function _payRefundSendCode(data) {
  return Service({
    url: urls.payRefundSendCode,
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/Common/index.js